import { AssessmentSection } from "@container/employer-assessment-section";
import AuthLayout from "@container/layout/auth";

export default function EmployerAssessPage() {
    return (
        <AuthLayout>
            <AssessmentSection />
        </AuthLayout>
    );
}
